import React from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useConfirmationMessage} from "../../../../hooks/useConfirmationMessage";
import {UserProfileForm} from "./UserProfileForm";
import {
    getUserProfile,
    setErrorData,
    setUserProfileUpdated,
    updateUserProfile
} from "../../../../slices/userProfileSlice";
import {DecisionDialog} from "../../cms/dialog-windows/DecisionDialog";
import {executeLogoutFetch} from "../../../../slices/loginFormSlice";
import {FormErrorDialog} from "../../../error/FormErrorDialog";
import {setCmsInEditMode, setConfirmLogout, setDashboardInEditMode} from "../../../../slices/globalParamsSlice";

export const UserProfile = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const renderConfirmation = useConfirmationMessage(setUserProfileUpdated);
    const {password, newPassword, repeatedPassword} = useSelector(state => state.userProfile.form);
    const {confirmLogout} = useSelector(state => state.globalParams.globalParams);
    const {errorData} = useSelector(state => state.userProfile.updateUserProfile);
    const hasChangedPassword = password && newPassword && repeatedPassword;
    const logoutPending = useSelector(state => state.login.logoutFetch.isLoading);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const resultAction = await dispatch(updateUserProfile());
        if (updateUserProfile.fulfilled.match(resultAction)) {
            await dispatch(getUserProfile());
            dispatch(setCmsInEditMode(false));
            dispatch(setDashboardInEditMode(false));
            hasChangedPassword ? dispatch(setConfirmLogout(true)) : renderConfirmation();
        }
    }

    return (
        <div className={'background'}>
            {confirmLogout &&
                <DecisionDialog msg={t('userProfileUpdatedWithPassword')}
                                onSubmit={() => dispatch(executeLogoutFetch({isInactive: false}))}
                                isLoading={logoutPending}
                />}
            <FormErrorDialog errorData={errorData} setErrorData={setErrorData}/>
            <form className={'cms-padded-view-container'}>
                <div className={'functions-header'}>
                    <div className={'section-heading'}>
                        {t('userProfile')}
                    </div>
                    <div className={'flex-wrapper-gapped'}>
                        <div className={'form-footer'}>
                            <div className={'general-button'} onClick={handleFormSubmit}>
                                {t('save')}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'form-grid'}>
                    <div className={'padded-form-fragment'}>
                        <UserProfileForm/>
                    </div>
                </div>
            </form>
        </div>
    )
}